export default {
  update: 'mnemonicsUpdate',
  seen: 'mnemonicsSeen',
  add: 'mnemonicsAdd'
}